import { useEffect, useState } from 'react';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { getMemberUpdate } from 'src/shared/services/memberUpdateService';

/** Returns the number of pending member updates */
export const useMemberUpdatesBadge = () => {
  const [pendingCount, setPendingCount] = useState(0);
  const { currentUser } = useGlobals();
  // Endpointen /MemberUpdate kräver MEMBER_APPROVE och returnerar 403 annars — vilket axios-
  // interceptorn visar som röd toast. Skippa anropet helt om användaren saknar permissionen.
  const canApprove = getPermission(currentUser, PermissionEnum.MemberApprove);

  useEffect(() => {
    if (!canApprove) return;
    getMemberUpdate(0, 1, 'memberUpdate_id', 'desc')
      .then((res) => {
        setPendingCount(res.data.totalItems);
      })
      .catch(() => undefined);
  }, [canApprove]);

  return pendingCount;
};
